module.exports = __webpack_public_path__ + "media/images/usage-coupon-3-03e3effa28dbb17f75f818e53dab0238.png";